import { IQuery } from 'core-ts-types';
import { IRegistrationSection } from '../../../interfaces/scheduler_interfaces';

import { IQueryMediator, ICommand } from 'core-ts-types';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { IDefineCommand } from 'core-ts-types';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';
import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { UpdateSectionSelectionCommand } from '../../../components/section_selections/commands/update_section_selection_command';

export type SelectAllRegistrationSectionsCommand = () => ng.IPromise<IQuery[]>;
angular
  .module('capability-ng-scheduler')
  .service(
    'selectAllRegistrationSectionsCommand',
    function selectAllRegistrationSectionsCommand(
      $q: ng.IQService,
      defineCommandORM: IDefineCommand,
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      updateSectionSelectionsCommand: UpdateSectionSelectionCommand
    ) {
      return defineCommandORM('selectAllRegistrationSectionsCommand', (deferred) => {
        const registrationSections = _4.map(
          ngRegisterSectionsDatasource.values(),
          (registrationSection: IRegistrationSection) => ({
            ...registrationSection,
            is_selected: _4.get(registrationSection, '_isEligibleForRegistration', true)
          })
        );

        ngRegisterSectionsDatasource.write(registrationSections);
        const updateSectionSelectionPromises = registrationSections.map((section) =>
          updateSectionSelectionsCommand(section.id, section.is_selected)
        );
        $q.all(updateSectionSelectionPromises).then(deferred.resolve);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/select_all_registration_sections_command.ts